const env = {
    // url: 'http://localhost:8000/',
    // api: 'http://localhost:8000/api/v1/app/',
    // baseUrl: 'http://localhost:8080/',
    baseUrl: 'https://admin-axs.techvision.dev/',
    url: 'https://apiaxs.techvision.dev/',
    api: 'https://apiaxs.techvision.dev/api/v1/app/',
    title: 'Admin | AXS Consultoria',
}
export default env;
